import {forEach as _forEach} from 'lodash';

import {
    BROADCAST_STATUS_APPROVED,
    BROADCAST_STATUS_CREATED,
    BROADCAST_STATUS_ON_AIR_READY,
    DISTRIBUTION_TYPE_LIVE,
} from '@constants/variables';

export const BROADCAST_AUTOMATION_TOOLTIPS = {
    A: 'Broadcast will be started automatically',
    F: 'Broadcast will be forced to start at the event content start time',
    S: 'Sequence based automation is activated',
    AS: 'Broadcast will be started automatically with sequence based automation activated',
    FS: 'Broadcast will be forced to start at the event content start time with sequence based automation activated',
};

const ELIGIBLE_BROADCAST_STATUSES = [
    BROADCAST_STATUS_CREATED,
    BROADCAST_STATUS_APPROVED,
    BROADCAST_STATUS_ON_AIR_READY,
];

export function hasEligibleLiveBroadcastStatus(distributionsByProduct) {
    let hasEligible = false;

    if (distributionsByProduct) {
        _forEach(distributionsByProduct, (element) => {
            _forEach(element.distribution_types, (distrType) => {
                if (DISTRIBUTION_TYPE_LIVE === distrType.distribution_type_id
                    && ELIGIBLE_BROADCAST_STATUSES.includes(distrType.broadcast_status_id)
                ) {
                    hasEligible = true;
                }
            });
        });
    }

    return hasEligible;
}

export function getBroadcastAutomationIndicator({
    matchId,
    stageId,
    startBroadcastAutomatically,
    forceBroadcastMargin,
    sequenceId,
    hasEligibleLiveBroadcastStatus: isEligible,
}) {
    if (!(matchId || stageId) || !isEligible) {
        return null;
    }

    const autoStart = Boolean(startBroadcastAutomatically);
    const hasForce = null != forceBroadcastMargin;
    const hasSequence = null != sequenceId;
    let label = null;

    if (autoStart && hasForce && hasSequence) {
        label = 'FS';
    } else if (autoStart && !hasForce && hasSequence) {
        label = 'AS';
    } else if (autoStart && hasForce && !hasSequence) {
        label = 'F';
    } else if (autoStart && !hasForce && !hasSequence) {
        label = 'A';
    } else if (!autoStart && !hasForce && hasSequence) {
        label = 'S';
    }

    if (!label) {
        return null;
    }

    return {
        label,
        tooltip: BROADCAST_AUTOMATION_TOOLTIPS[label],
    };
}
